import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Location } from '@freelancer/location';
import { UI_CONFIG } from '@freelancer/ui/ui.config';

export const RedirectToNewCarrierGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const location = inject(Location);
  const uiConfig = inject(UI_CONFIG);

  if (uiConfig.theme !== 'freightlancer') {
    return true;
  }

  return location.createUrlTree(['/new-carrier']);
};
